import React from 'react';
import '../../css/common/InfoCard.css';

const InfoCard = ({ title, content, icon, className = '' }) => {
  return (
    <div className={`info-card ${className}`}>
      <div className="info-card-header">
        {icon && <div className="info-card-icon">{icon}</div>}
        <h3 className="info-card-title">{title}</h3>
      </div>
      <div className="info-card-content">
        {content}
      </div>
    </div>
  );
};

export default InfoCard;
